import api from '../../../api/client';
import React from "react";
import { Modal, Form, Input, Button, Upload, Space, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";
import { useFarmProfile } from "../../../contexts/FarmProfileContext";
import { useSelector } from "react-redux";
import config from "../../../config";

const { TextArea } = Input;

const InvoiceEmailModal = ({ open, onClose, invoice }) => {
  const [form] = Form.useForm();
  const { profile } = useFarmProfile();
  const account = useSelector((state) => state.account.user);
  const environment =
    window.location.hostname === "localhost" ? "development" : "production";
  const apiUrl = config[environment].apiUrl;

  const handleSend = async (values) => {
    try {
      await api.post(`/api/invoices/${invoice.id}/send-email`, {
        invoiceId: invoice.id,
        ...values,
      });

      message.success("Email sent successfully");
      onClose();
    } catch (err) {
      message.error("Failed to send email");
    }
  };

  return (
    <Modal
      title={`Send Invoice #${invoice.id}`}
      open={open}
      onCancel={onClose}
      width={800}
      footer={null}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSend}
        initialValues={{
          to: invoice?.stakeholder?.email,
          subject: `Invoice #${invoice.id}`,
          body: `Dear ${
            invoice.stakeholder.name || "Customer"
          },\n\nPlease find attached invoice #${invoice.id}.\n\nRegards.\n${
            account?.firstname
          }\n${profile?.name}`,
        }}
      >
        <Form.Item name="to" label="To" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="cc" label="Cc">
          <Input />
        </Form.Item>

        <Form.Item name="subject" label="Subject">
          <Input />
        </Form.Item>

        <Form.Item name="body" label="Message">
          <TextArea rows={8} />
        </Form.Item>

        <Form.Item label="Attachments">
          <Upload>
            <Button icon={<UploadOutlined />}>Attach File</Button>
          </Upload>
        </Form.Item>

        <Space style={{ float: "right" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit">
            Send
          </Button>
        </Space>
      </Form>
    </Modal>
  );
};

export default InvoiceEmailModal;
